var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "help") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.751 19.076h-2v-0.49c0-1.138 0.49-2.053 1.416-2.646 0.309-0.198 0.625-0.375 0.941-0.551 0.334-0.186 0.666-0.369 0.984-0.588 0.725-0.497 1.084-1.309 0.965-2.172-0.068-0.497-0.324-0.876-0.783-1.157-1.021-0.631-2.768-0.618-3.859-0.242-0.719 0.247-1.494 0.906-1.494 1.77h-2c0-1.605 1.143-3.077 2.846-3.661 1.496-0.517 3.879-0.604 5.557 0.431 0.971 0.597 1.564 1.491 1.715 2.586 0.223 1.604-0.473 3.174-1.812 4.095-0.371 0.255-0.756 0.471-1.145 0.687-0.279 0.155-0.56 0.31-0.834 0.486-0.348 0.223-0.496 0.511-0.496 0.962v0.49z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.92 22h2v2h-2v-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4c6.617 0 12 5.383 12 12s-5.383 12-12 12-12-5.383-12-12 5.383-12 12-12zM16 2c-7.732 0-14 6.268-14 14s6.268 14 14 14c7.732 0 14-6.268 14-14s-6.268-14-14-14v0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityHelp);
export default __webpack_public_path__ + "static/media/unity_help.9043ddb9124134c7c0b75b742090bdf3.svg";
export { ForwardRef as ReactComponent };